import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import DiscoverNispandRoutes from './Constants/routes'

const DiscoverNispand = () => {
  const match = useRouteMatch()
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {DiscoverNispandRoutes.map(({ path, Component, id, exact }) => (
          <Route
            path={`${match.url}${path}`}
            component={Component}
            exact={exact}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/discover-nispand" />
      </Switch>
    </>
  );
}

export default DiscoverNispand